import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
// Imported for its side effect, and imported early on purpose: it must be
// listening for `beforeinstallprompt` before the first render.
import './pwaInstall';
import App from './App';
import MaintenanceGate from './components/MaintenanceGate';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* "Being updated" screen during a deploy, and a friendly screen instead of a white page on a crash */}
    <MaintenanceGate>
      <App />
    </MaintenanceGate>
  </React.StrictMode>
);

serviceWorkerRegistration.register();